import _ from "lodash";
import React, {Fragment} from 'react';
import {
    Container,
    Grid,
    Step,
    StepLabel,
    StepContent,
    Stepper,
    Button,
    FormHelperText
} from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import {CreateCaseForm, UserForm, PriceForm, CreditCardForm, MultiRoute, AddLocationForm, DateTime} from '../component'
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {
    caseFormChange,
    priceFormChange,
    caseSubmit,
    findLawyer,
    resetCaseForm,
    resetPriceForm
} from "../vendors/actions/case";
import {locationFormChange} from "../vendors/actions/location";
import {dateTimeFormChange} from "../vendors/actions/dateTime";
import {userExist} from "../vendors/actions/user";
import {userRegisterFormChange} from "../vendors/actions/user";
import {resetCreditCard, addCreditCard} from '../vendors/actions/creditCard'
import {Modals} from "../component";
import {
    CaseFormSerializer,
    UserFormSerializer,
    CreditCardSerializer,
    priceFormSerializer,
    LocationFormSerializer,
    DateFormSerializer
} from "../vendors/utils/serializers";
import {isMobileBrowser, scrollToElemError} from "../vendors/utils/common";


interface OwnProps {
    getUserInfo?: any,
    caseFormChange?: any
    priceFormChange?: any,
    userRegisterFormChange?: any
    addCreditCard?: any
    caseSubmit?: any,
    findLawyer?: any,
    ignoreUserForm?: boolean,
    resetCreditCard?: any,
    userExist?: any

    [key: string]: any
}

interface MainState {
    activeStep: number,
    progressError: boolean
    steps: any,
    stepsOrigin: any,
    allValid: boolean
}

interface ConnectStateProps {
    User: any,
    UserRegisterForm: any,
    CaseForm: any,
    DateTime: any
}

interface ConnectDispatchProps {
    caseFormChange?: (data: any) => void;
    priceFormChange?: (data: any) => void;
    userRegisterFormChange?: (data: any) => void;
    addCreditCard?: (data: any) => void;
    caseSubmit?: (data: any) => void;
    findLawyer?: (data: any) => void;
    resetCreditCard?: (data: any) => void;
    userExist?: (data: any) => void;
    locationFormChange?: (data: any) => void;
    dateTimeFormChange?: (data: any) => void;
    resetCaseForm: () => void;
    resetPriceForm: () => void;
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

const progressText = 'Upload is in progress, please wait.';

const steps = [{
    ownIndex: 0,
    title: 'Case Details',
    error: false,
    form: 'CaseForm',
    formAction: 'caseFormChange',
    component: <CreateCaseForm/>
}, {
    ownIndex: 1,
    title: 'Personal Details',
    error: false,
    form: 'UserRegisterForm',
    formAction: 'userRegisterFormChange',
    secondary: 'User',
    component: <UserForm/>
}, {
    ownIndex: 2,
    title: 'Pricing',
    error: false,
    form: 'PriceForm',
    formAction: 'priceFormChange',
    component: <PriceForm/>
}, {
    ownIndex: 3,
    title: 'Location',
    error: false,
    form: 'LocationForm',
    formAction: 'locationFormChange',
    component: <AddLocationForm/>
}, {
    ownIndex: 4,
    title: 'Date & Time',
    error: false,
    form: 'DateTime',
    formAction: 'dateTimeFormChange',
    component: <DateTime/>
}, {
    ownIndex: 5,
    title: 'Payment Details',
    error: false,
    form: 'CreditCardForm',
    formAction: 'addCreditCard',
    component: <CreditCardForm/>
}];


const loginLawyerRoute = [
    {
        link: '/',
        title: 'Find a Lawyer',
        className: 'active',
    },
    {
        link: '/login',
        title: 'Log In',
        className: '',
    }
];

class FindLawyerSection extends React.Component<HeaderProps, MainState> {
    state = {
        progressError: false,
        activeStep: 0,
        steps: steps,
        stepsOrigin: steps.slice(0),
        allValid: false
    };

    componentDidMount() {
        let {steps, stepsOrigin} = this.state;

        const {ignoreUserForm = false} = this.props;
        if (ignoreUserForm) {
            steps.splice(1, 1);
            // forms.splice(1, 1);
            stepsOrigin.splice(1, 1);
        }
        this.setState({steps, stepsOrigin})
    }

    componentWillUnmount() {
        this.props.resetCaseForm()
        this.props.resetCreditCard()
        this.props.resetPriceForm()
        this.setState({activeStep: 0})
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {stepsOrigin} = state;
        let {activeStep} = state;
        let doubleStep = false;
        let validStepsLength = 0;
        const {CaseForm, UserRegisterForm, User, PriceForm, ignoreUserForm} = props;
        const paymentType = PriceForm.data.payment_type;

        let steps = stepsOrigin.slice(0);

        if (paymentType && paymentType.value !== "single_appearance") {
            steps = steps.filter((s: any) => s.form !== 'LocationForm' && s.form !== 'DateTime');
        }

        if (paymentType && (paymentType.value === "contingency" || paymentType.value === "pro_bono")) {
            steps.pop();
        }

        const validSteps = steps.filter((step: any) => {
            if (!doubleStep) {
                const secondary = props[step.secondary];
                doubleStep = !!(secondary && Object.keys(secondary).length > 0);
            }

            return props[step.form]?.valid;
        });

        if (validSteps?.length) {
            const stepsIndex = validSteps.map((s: any, index: number) => index);
            const max = Math.max(...stepsIndex);
            activeStep = max + (doubleStep ? 2 : 1);
        }

        validStepsLength = Object.keys(props.User).length && !ignoreUserForm ? validSteps.length + 1 : validSteps.length;
        return {
            allValid: validStepsLength === steps.length,
            steps,
            activeStep
        };
    }

    changeStep = (e: any, step: number) => {
        const {activeStep, steps} = this.state;
        step = activeStep === 0 ? 0 : activeStep - 1;
        if (steps[step] && steps[step].component) {
            const form = this.props[steps[step].form];
            if (steps[step].formAction) {
                const action = this.props[steps[step].formAction];
                for (const prop in form.data) {
                    const value = form.data[prop].value;
                    action({value, field: prop, validate: true});
                }
            }

            steps[step].error = !form.valid;
            this.setState({steps});
        }

    };

    validateAllForms(forms: any) {
        for (const single of forms) {
            for (const prop in single.form.data) {
                const value = single.form.data[prop].value;
                const err = single.form.data[prop].error;
                // if (single.key !== 'addCreditCard') {
                if (typeof this.props[single.key] === 'function' && !err) {
                    this.props[single.key]({value, field: prop, validate: true});
                }
                // }
            }
        }
    }

    submit() {
        const {CaseForm, PriceForm, UserRegisterForm, CreditCardForm, User, Documents, LocationForm, DateTime} = this.props;

        const priceData = priceFormSerializer(PriceForm.data);
        const caseData = CaseFormSerializer(CaseForm.data);
        const locationData = LocationFormSerializer(LocationForm.data);
        const date = DateFormSerializer(DateTime.data);
        Object.assign(caseData, {...priceData, ...locationData, ...date});
        const documents = Documents.uploads || [];
        const user = !Object.keys(User).length ? UserFormSerializer(UserRegisterForm.data) : undefined;
        const paymentMethod = CreditCardForm.data.paymentMethod.value;
        const creditCard = !paymentMethod ? CreditCardSerializer(CreditCardForm.data) : undefined;
        this.props.findLawyer({
            caseData,
            user,
            creditCard,
            paymentMethod,
            documents
        })

    }

    async preSubmit() {
        const {CaseForm,
            UserRegisterForm,
            CreditCardForm,
            PriceForm,
            Documents,
            ignoreUserForm,
            LocationForm,
            DateTime
        } = this.props;
        const {allValid, steps} = this.state;

        const paymentType = PriceForm.data.payment_type;

        let forms: Array<any> = [
            {form: CaseForm, key: 'caseFormChange'},
            {form: UserRegisterForm, key: 'userRegisterFormChange'},
            {form: PriceForm, key: 'priceFormChange'},
            {form: CreditCardForm, key: 'addCreditCard'},
            {form: LocationForm, key: 'locationFormChange'},
            {form: DateTime, key: 'dateTimeFormChange'}
        ];
        let userExist: boolean = false;

        if (ignoreUserForm) {
            forms.splice(1, 1);
        }

        if (paymentType && paymentType.value !== "single_appearance") {
            steps.pop();
            steps.pop();
        }

        this.state.progressError && this.setState({progressError: false});
        if (Documents.fileLoading) {
            return this.setState({progressError: true})
        }

        if (!ignoreUserForm && UserRegisterForm.data?.email?.value) {
            userExist = await this.checkUser(UserRegisterForm.data?.email?.value);

            if (userExist) {
                this.props.userRegisterFormChange({
                    value: UserRegisterForm.data?.email?.value,
                    field: 'email',
                    apiError: true
                });
                scrollToElemError()
            }
        }

        if (allValid && !userExist) {
            this.submit();
        } else {
            this.validateAllForms(forms);
            scrollToElemError();
        }
    }

    async checkUser(email: any) {
        const res = await this.props.userExist({email});
        return res.payload.exists
    }

    render() {
        const {activeStep, steps, allValid, progressError} = this.state;
        const {title, ignoreUserForm} = this.props;
        const allowSubmit = activeStep >= steps.length - 1 || allValid;

        return (
            <Fragment>
                <Grid
                    className={`d-flex 
                    ${window.location.href.indexOf('find-lawyer') === -1 && 'custom-grid-right-width home-mobile-border-radius'} 
                    ${ignoreUserForm || isMobileBrowser() ? '' : 'scroll-area'}`}
                    item
                    xs={12}
                    md={ignoreUserForm ? 10 : 7}
                    lg={ignoreUserForm ? 9 : 7}
                >
                    <div
                        className={`${ignoreUserForm ? 'w-100' : 'mx-auto'} right-section-custom`}>
                        <Container maxWidth="lg">
                            {!ignoreUserForm && <div className={`multi-route-wrapper main-context-left-m`}>
                                <MultiRoute routes={loginLawyerRoute}/>
                                <div className="mb-4 right-section-title">
                                    <Typography className="primary-title">
                                        {title}
                                    </Typography>
                                    <Typography className={'sec-title d-block'} gutterBottom>
                                        Finding legal help has never been easier. Let’s get started.
                                    </Typography>
                                </div>
                            </div>}
                            <div className="MuiTypography-root mt-1">
                                <Stepper className="create-case-stepper" activeStep={activeStep} orientation="vertical">
                                    {steps.map((val, index) => (
                                        <Step key={index} active={activeStep >= index}>
                                            <StepLabel
                                                onClick={(e) => this.changeStep(e, index)}>{val.title}
                                            </StepLabel>
                                            <StepContent
                                                className={`${val.form} ${activeStep >= index ? 'passed' : ''}`}>
                                                {val.component}
                                                {index - 1 === steps.length - 2 &&
                                                <div style={{marginTop: '16px', marginBottom: '18px'}}>
                                                    <Typography style={{fontSize: '12px'}} variant="caption"
                                                                gutterBottom>
                                                        By clicking the Find a Lawyer button below you agree to our
                                                        <a href={'http://www.appearme.com/terms-of-use/'}
                                                           target={'_blank'}
                                                           className="mr-1 ml-1">
                                                            Terms of Use
                                                        </a>
                                                        and
                                                        <a href={'https://www.appearme.com/privacy-policy/'}
                                                           target={'_blank'}
                                                           className="ml-1">
                                                            Privacy Policy
                                                        </a>.
                                                    </Typography>
                                                </div>}
                                            </StepContent>
                                        </Step>
                                    ))}
                                    {allowSubmit && <Step style={{marginTop: '-10px'}} active={allowSubmit}>
                                        <StepLabel style={{marginBottom: '-12px'}}
                                                   icon={<span className={'empty-step-circle'}/>} className={'mb-1'}>
                                            <Button
                                                onClick={() => this.preSubmit()}
                                                variant="contained"
                                                color="primary"
                                                className={`find-lawyer-btn ${window.location.href.indexOf('find-lawyer') === -1 && 'and-lawyers-button'}`}>Find a Lawyer
                                            </Button>
                                        </StepLabel>
                                    </Step>}
                                </Stepper>
                                {progressError &&
                                <FormHelperText className={'float-right Mui-error'}>{progressText}</FormHelperText>}
                                <div style={!isMobileBrowser() ? {height: '80px'} : {height: '144px'}}/>
                            </div>
                        </Container>
                    </div>
                </Grid>
                {allValid && <Modals.CaseSubmitModal/>}
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {
        User,
        CaseForm,
        PriceForm,
        UserRegisterForm,
        CreditCardForm,
        Documents,
        LocationForm,
        DateTime
    } = state;
    return {
        User,
        UserRegisterForm,
        CaseForm,
        PriceForm,
        CreditCardForm,
        Documents,
        LocationForm,
        DateTime
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        caseFormChange: (data: any) => dispatch(caseFormChange(data)),
        priceFormChange: (data: any) => dispatch(priceFormChange(data)),
        userRegisterFormChange: (data: any) => dispatch(userRegisterFormChange(data)),
        caseSubmit: (data: any) => dispatch(caseSubmit(data)),
        resetCreditCard: () => dispatch(resetCreditCard()),
        resetCaseForm: () => dispatch(resetCaseForm()),
        resetPriceForm: () => dispatch(resetPriceForm()),
        addCreditCard: (data: any) => dispatch(addCreditCard(data)),
        findLawyer: (data: any) => dispatch(findLawyer(data)),
        userExist: (data: any) => dispatch(userExist(data)),
        locationFormChange: (data: any) => dispatch(locationFormChange(data)),
        dateTimeFormChange: (data: any) => dispatch(dateTimeFormChange(data)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(FindLawyerSection);
